"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
// eslint-disable-next-line import/prefer-default-export
var PlaybackPosition = /** @class */ (function () {
    function PlaybackPosition() {
    }
    PlaybackPosition.createInstance = function (plainObject) {
        return class_transformer_1.plainToClass(PlaybackPosition, plainObject);
    };
    PlaybackPosition.createInstances = function (plainObjectArray) {
        return class_transformer_1.plainToClass(PlaybackPosition, plainObjectArray);
    };
    __decorate([
        class_transformer_1.Type(function () { return Date; })
    ], PlaybackPosition.prototype, "created", void 0);
    __decorate([
        class_transformer_1.Type(function () { return Date; })
    ], PlaybackPosition.prototype, "updated", void 0);
    return PlaybackPosition;
}());
exports.PlaybackPosition = PlaybackPosition;
//# sourceMappingURL=PlaybackPosition.js.map